import { Component, OnDestroy, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { FilterService } from '../../generic/service/filter.service';

@Component({
    selector: 'filter-search',
    templateUrl: 'filter.search.component.html',
    styleUrls: ['./filter.component.scss'],
    standalone: true,
    imports: [FormsModule, ReactiveFormsModule],
})
export class FilterSearchComponent implements OnDestroy {
    private filterService = inject(FilterService);
    private formBuilder = inject(UntypedFormBuilder);

    form: UntypedFormGroup;
    searchText: string;

    private filterStateChangedSubscription: Subscription;

    constructor() {
        const filterState = this.filterService.getFilterState();
        this.searchText = filterState.searchText;

        this.form = this.formBuilder.group({
            searchText: ['', Validators.required],
        });

        this.filterStateChangedSubscription =
            this.filterService.filterStateChanged.subscribe(newState => {
                this.form.get('searchText')?.setValue(newState.searchText);
            });
    }

    ngOnDestroy(): void {
        this.filterStateChangedSubscription.unsubscribe();
    }

    /**
     * Form submit handler
     *
     * @param value
     */
    onSubmit(value: any) {
        const filterState = this.filterService.getFilterState();

        const formValues = this.form.value;

        if (formValues.searchText !== filterState.searchText) {
            // Pass empty values to be able to remove search
            this.filterService.setSearchText(formValues.searchText);
        }
    }
}
